import React from 'react'
import styled from 'styled-components'

import { Box } from "grommet"

const PointerBox = styled(Box)`
  cursor: pointer;
`;

export const CircularButton = ({ icon, handleClick=null }) => {
    return (
        <PointerBox
            size="12px"
            onClick={handleClick}
            margin={{ right: 'small' }}
            direction="row"
            pad="5px"
            gap="xsmall"
            align="center"
            border={{ size: "small", side: "all", color: "brand" }}
            round="medium"
            background={{ color: "brand", opacity: "strong" }}
        >
            {icon}
        </PointerBox>
    )
}
